/* eslint-disable */

import { Outlet } from 'react-router-dom';
import classes from './StockThreshold.module.css';
import DataTable from '../../components/common/datatable/Datatable';
import {
  FilterTable,
  TableAction,
  TableDetailCell,
  TableHeaderCell,
  Warehouse,
  WarehouseStock,
} from '../../model/models-module';
import { useCallback, useEffect, useState } from 'react';
import Topbar from '../../components/common/topbar/Topbar';
import CustomAutocompleteInput, {
  DropdownOptionsType,
} from '../../components/common/autocomplete-input/AutocompleteInput';
import { Form, Formik } from 'formik';
import { useData } from '../../components/hooks/useData';
import { GridDTO } from '../../model/dto-module';
import { CircularProgress, Grid, Tooltip, Typography } from '@mui/material';
import WarehouseService from '../../services/WarehouseService';
import EditIcon from '@mui/icons-material/Edit';
import StockThresholdSingleEdit from './single-edit/StockThresholdSingleEdit';
import ButtonToCopy from '../../components/common/ButtonToCopy';

export interface UserWarehouses {
  warehouseId: number;
  warehouseCode: string;
  warehouseDescription: string;
  hasPermission: boolean;
}

const StockThreshold = () => {
  const [allData, setAllData] = useState<WarehouseStock[]>([]); // Almacena todos los datos de la tabla
  const [allWarehouses, setAllWarehouses] = useState<Warehouse[]>([]); // Almacena todos los warehouses
  const [selectedWarehouse, setSelectedWarehouse] = useState<
    DropdownOptionsType | undefined
  >(undefined); //Warehouse Seleccionado
  const [dataShow, setDataShow] = useState<TableDetailCell[]>([]);
  const [dataTo, setDataTo] = useState<number>(20);
  const [page, setPage] = useState<number>(1);
  const [dataHeader, setDataHeader] = useState<TableHeaderCell[]>([]);
  const [endpoint, setEndpoint] = useState<string>('');
  const [loadingDatagrid, errorDatagrid, rowsDatagrid] = useData<
    GridDTO<WarehouseStock>
  >(endpoint, 'GET');
  const [skuFilter, setSkuFilter] = useState<string>();
  const [descriptionFilter, setDescriptionFilter] = useState<string>();
  const [dataEdit, setDataEdit] = useState<WarehouseStock>();
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  const [refreshDatagrid, setRefreshDatagrid] = useState<boolean>(false);
  const [showSpinner, setShowSpinner] = useState<boolean>(false);

  const service: WarehouseService = WarehouseService.Instance;

  const editRow = useCallback(
    (d: WarehouseStock) => {
      setDataEdit(d);
    },
    [setDataEdit]
  );

  function reloadTable() {
    if (selectedWarehouse) {
      setShowSpinner(true);
      setEndpoint(`/warehouses-stocks/${selectedWarehouse.id}`);
      setRefreshDatagrid(true);
    }
  }

  useEffect(() => {
    if (dataEdit) {
      setShowEditModal(true);
    }
  }, [dataEdit]);

  const formatStock = (value?: number) => {
    if (value && value < 10000) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    return value?.toLocaleString('es-ES');
  };

  // Función helper para filtrar los datos
  const getFilteredData = useCallback(() => {
    let filteredData = allData;

    if (skuFilter) {
      filteredData = filteredData.filter(
        (item) =>
          item.sku && item.sku.toLowerCase().includes(skuFilter.toLowerCase())
      );
    }

    if (descriptionFilter) {
      filteredData = filteredData.filter(
        (item) =>
          item.productDescription &&
          item.productDescription
            .toLowerCase()
            .includes(descriptionFilter.toLowerCase())
      );
    }

    return filteredData;
  }, [allData, skuFilter, descriptionFilter]);

  useEffect(() => {
    const filteredData = getFilteredData();

    const start = (page - 1) * dataTo;
    const end = start + dataTo;
    const paginatedData = filteredData.slice(start, end);

    const data2: TableDetailCell[] = paginatedData.map(
      (warehousesStock) =>
        new TableDetailCell(
          {
            distributionCentre: warehousesStock.distributionCentre?.code,
            warehouseDescription: warehousesStock.warehouse?.description,
            productDescription: warehousesStock.productDescription,
            sku: warehousesStock.sku,
            stockMinimum: formatStock(warehousesStock.stockMinimum),
            stockMaximun: formatStock(warehousesStock.stockMaximun),
            stockMinimumTransfer: formatStock(
              warehousesStock.stockMinimumTransfer
            ),
          },
          [
            new TableAction({
              label: 'Editar',
              action: () => {
                editRow(warehousesStock);
                setRefreshDatagrid(true);
              },
              icon: (
                <span className={classes.editIcon}>
                  <EditIcon></EditIcon>
                </span>
              ),
            }),
          ],
          new Map<string, React.ReactNode>([
            [
              'productDescription',

              <div
                key={warehousesStock.productDescription}
                className={classes['textWithCopy']}
              >
                {warehousesStock.productDescription != null &&
                warehousesStock.productDescription.length < 20 ? (
                  <Typography
                    className={classes.productDescription}
                    fontSize={'0.875rem'}
                  >
                    {warehousesStock.productDescription}
                  </Typography>
                ) : (
                  <Tooltip title={warehousesStock.productDescription}>
                    <Typography
                      className={classes.productDescription}
                      fontSize={'0.875rem'}
                    >
                      {warehousesStock.productDescription}
                    </Typography>
                  </Tooltip>
                )}
                {warehousesStock.productDescription != null ? (
                  <ButtonToCopy
                    text={warehousesStock.productDescription}
                  ></ButtonToCopy>
                ) : null}
              </div>,
            ],
            [
              'sku',

              <div
                key={warehousesStock.sku}
                className={classes['textWithCopy']}
              >
                {warehousesStock.sku != null &&
                warehousesStock.sku.length < 20 ? (
                  <Typography className={classes.sku} fontSize={'0.875rem'}>
                    {warehousesStock.sku}
                  </Typography>
                ) : (
                  <Tooltip title={warehousesStock.sku}>
                    <Typography className={classes.sku} fontSize={'0.875rem'}>
                      {warehousesStock.sku}
                    </Typography>
                  </Tooltip>
                )}
                {warehousesStock.sku != null ? (
                  <ButtonToCopy text={warehousesStock.sku}></ButtonToCopy>
                ) : null}
              </div>,
            ],
          ])
        )
    );

    setDataShow(data2);
  }, [
    allData,
    dataTo,
    page,
    skuFilter,
    descriptionFilter,
    editRow,
    getFilteredData,
  ]);

  // Resetear página a 1 cuando cambian los filtros
  useEffect(() => {
    setPage(1);
  }, [skuFilter, descriptionFilter]);

  useEffect(() => {
    const loadWarehouses = async () => {
      try {
        const data = await service.findAll();
        setAllWarehouses(data.results);
      } catch (err) {
        console.log('Error al cargar los Almacenes');
      }
    };
    loadWarehouses();
  }, []);

  useEffect(() => {
    setDataHeader([
      new TableHeaderCell({
        label: 'CD',
        key: 'distributionCentre',
        sorteable: false,
        colStyle: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start',
          minWidth: '150px',
          height: '100%',
        },
      }),
      new TableHeaderCell({
        label: 'Almacén',
        key: 'warehouseDescription',
        sorteable: false,
        colStyle: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start',
          minWidth: '150px',
          height: '100%',
        },
      }),
      new TableHeaderCell({
        label: 'SKU',
        key: 'sku',
        sorteable: false,
        filter: new FilterTable({
          onChange: (newVal: any) => {
            setSkuFilter(newVal.trim());
          },
          value: skuFilter ?? '',
          placeholder: 'Busca aqui',
        }),
      }),
      new TableHeaderCell({
        label: 'Descripción',
        key: 'productDescription',
        sorteable: false,
        filter: new FilterTable({
          onChange: (newVal: any) => {
            setDescriptionFilter(newVal.trim());
          },
          placeholder: 'Busca aquí por descripción',
          value: descriptionFilter ?? '',
        }),
      }),
      new TableHeaderCell({
        label: 'Stock Mínimo',
        key: 'stockMinimum',
        sorteable: false,
        colStyle: {
          diplay: 'flex',
          alignItems: 'center',
          textAlign: 'center',
          minWidth: '150px',
        },
        align: 'center',
      }),
      new TableHeaderCell({
        label: 'Stock Máximo',
        key: 'stockMaximun',
        sorteable: false,
        colStyle: {
          diplay: 'flex',
          alignItems: 'center',
          textAlign: 'center',
          minWidth: '150px',
        },
        align: 'center',
      }),
      new TableHeaderCell({
        label: 'Stock Min. Trasnf.',
        key: 'stockMinimumTransfer',
        sorteable: false,
        colStyle: {
          diplay: 'flex',
          alignItems: 'center',
          textAlign: 'center',
          minWidth: '150px',
        },
        align: 'center',
      }),
    ]);
  }, [skuFilter, descriptionFilter]);

  useEffect(() => {
    if (selectedWarehouse) {
      setEndpoint(`/warehouses-stocks/${selectedWarehouse.id}`);
    } else {
      setEndpoint('');
      setAllData([]);
    }
  }, [selectedWarehouse]);

  useEffect(() => {
    if (!errorDatagrid && rowsDatagrid) {
      setAllData(rowsDatagrid.results);
      setShowSpinner(false);
    }
  }, [errorDatagrid, rowsDatagrid]);

  useEffect(() => {
    if (refreshDatagrid) {
      setRefreshDatagrid(false);
      setEndpoint((prevEndpoint) =>
        prevEndpoint ? `${prevEndpoint}?refresh=${Date.now()}` : ''
      );
    }
  }, [refreshDatagrid]);

  return (
    <div className={classes.stockThresholdPage}>
      {showSpinner || loadingDatagrid ? (
        <div className="loadingPage">
          <CircularProgress className="circleProgress" />
        </div>
      ) : null}
      <Topbar
        title={'Configurar Umbrales'}
        subtitle={''}
        hasReloadIcon
        reloadPage={reloadTable}
      />
      <div className={classes['container-abm-page']}>
        <Grid container justifyContent={'space-between'} marginBottom="20px">
          <Grid item xs={4}>
            <Formik
              initialValues={{ warehouse: undefined }}
              onSubmit={(values) => {
                setSelectedWarehouse(values.warehouse);
              }}
              enableReinitialize={true}
            >
              {({ handleSubmit, submitForm }) => (
                <Form onSubmit={handleSubmit}>
                  {allWarehouses.length > 0 ? (
                    <CustomAutocompleteInput
                      name="warehouse"
                      label="Almacén"
                      defaultOptions={allWarehouses.map((w) => ({
                        id: w.id,
                        value: w.code,
                        label: `${w.code}`,
                      }))}
                      onOptionSelect={() => {
                        setSkuFilter('');
                        setDescriptionFilter('');
                        setPage(1);
                        submitForm();
                      }}
                      onClear={() => {
                        setSkuFilter('');
                        setDescriptionFilter('');
                        setSelectedWarehouse(undefined);
                        setPage(1);
                      }}
                      cantidadCaracteres={0}
                    />
                  ) : (
                    <CircularProgress size={30} />
                  )}
                </Form>
              )}
            </Formik>{' '}
          </Grid>
        </Grid>
        {dataShow.length > 0 ? (
          <div className={classes['table-templates-container']}>
            <DataTable
              headers={dataHeader}
              rows={dataShow}
              countItems={getFilteredData().length}
              rowsPerPage={dataTo}
              hasActions={true}
              appendOnScrollToBottom={false}
              onPageSizeChange={(size) => {
                setDataTo(size);
                setPage(1);
              }}
              onPageChange={(page: number) => {
                setPage(page);
              }}
              pageSelected={page}
              pageable={true}
              selectable={false}
              className=" thinner stock-distribution-table table-row-centered"
            ></DataTable>
          </div>
        ) : null}
      </div>

      {showEditModal && dataEdit ? (
        <StockThresholdSingleEdit
          item={dataEdit}
          open={showEditModal}
          onClose={(e, reason) => {
            console.warn(e);

            if (reason && reason === 'backdropClick') return;

            setShowEditModal(false);
            setDataEdit(undefined);

            if (reason && reason === 'confirm') {
              setRefreshDatagrid(true);
            }
          }}
        />
      ) : null}
      <Outlet />
    </div>
  );
};

export default StockThreshold;
